var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCustomAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 19.5H6.43C6.09 19.5 5.76 19.36 5.52 19.12C5.28 18.88 5.14 18.55 5.14 18.21V16.28H6.43V18.21H14.14V2.79H6.43V4.72H5.14V2.79C5.14 2.45 5.28 2.12 5.52 1.88C5.76 1.64 6.09 1.5 6.43 1.5H14.14C14.48 1.5 14.81 1.64 15.05 1.88C15.29 2.12 15.43 2.45 15.43 2.79V18.22C15.43 18.56 15.29 18.89 15.05 19.13C14.81 19.37 14.48 19.51 14.14 19.51V19.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81 13.45L9.11 11.14H1.5V9.85H9.11L6.81 7.54L7.72 6.63L11.58 10.49L7.72 14.35L6.81 13.44V13.45Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.28H21V16.28H19.5V19.28H16.5V20.78H19.5V23.78H21V20.78H24V19.28Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCustomAccess);
export default __webpack_public_path__ + "static/media/ic-custom-access.ac3f14d2f46f728706f3aac81b3b311a.svg";
export { ForwardRef as ReactComponent };